import { HTMLAttributes } from 'react';

import { EraserIcon } from '@radix-ui/react-icons';
import { type Editor } from '@tiptap/react';

import { Button } from '../../../primitives/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../primitives/tooltip';

import { cn } from '../../../utils/cn';
import { Values } from '../../../utils/types';

export const ERASER_TYPE = {
  all: 'all',
  marks: 'marks',
} as const;

const COMMAND = {
  [ERASER_TYPE.all]: {
    ariaLabel: 'Borrar todo el formato',
    icon: <EraserIcon className="size-4" />,
    tooltip: 'Borrar todo el formato',
    command: (editor: Editor) => editor.chain().focus().unsetAllMarks().clearNodes().run(),
  },
  [ERASER_TYPE.marks]: {
    ariaLabel: 'Borrar formato del texto',
    icon: (
      <>
        <span>A</span>
        <EraserIcon className="mb-[-2px] ml-[-6px] size-3" />
      </>
    ),
    tooltip: 'Borrar formato del texto',
    command: (editor: Editor) => editor.chain().focus().unsetAllMarks().run(),
  },
};

interface ButtonEraserProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  editor: Editor;
  type: Values<typeof ERASER_TYPE>;
}

export function ButtonEraser({ className, editor, type }: ButtonEraserProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          <Button
            aria-label={COMMAND[type].ariaLabel}
            className={cn('text-destructive', className)}
            disabled={!editor.isEditable}
            size="icon"
            variant="ghost"
            onClick={() => COMMAND[type].command(editor)}
          >
            {COMMAND[type].icon}
          </Button>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p className="flex flex-col">{COMMAND[type].tooltip}</p>
      </TooltipContent>
    </Tooltip>
  );
}
